// extracted by mini-css-extract-plugin
module.exports = {"info__container":"style_info__container__wUFd5","info__span":"style_info__span__1BaEQ","info__text":"style_info__text__1ysvw"};